// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as ppa from '../thunks/api/ppa'
import * as articlesentimentv2 from './api/articlesentimentv2'
import * as pa from './api/pa'
import {displayErrorMessage, displaySuccessMessage, log} from '@insticator/insticator-ui'
import { downloadLink } from '@insticator/insticator-ui/dist/utils/files';


// Article Sentiment 2.0 

export const approveArticleSentimentV2AccessRequest = createAsyncThunk('articlesentimentv2/approveArticleSentimentV2AccessRequest',
    async (payload, { rejectWithValue }) => {
        const { accountUUID, userEmail } = payload
        try {
          const response = await articlesentimentv2.approveArticleSentimentV2Access(accountUUID)
          // if logged in non-internal user sent the request
          if(userEmail) {
            store.dispatch(displaySuccessMessage('Your request was sent successfully'))
            return {
              userEmail,
              accountUUID,
              requestStatus: 'PENDING' 
            }
          }
          // if mocked user sent the request
          return response.data
        } catch(err) {
          const error = `There was an issue approving this account`
          store.dispatch(displayErrorMessage(error))
          return null
        }
    }
  );

  
export const fetchArticleSentimentV2Config = createAsyncThunk('articlesentimentv2/fetchArticleSentimentV2Config',
    async payload => {
      const { siteUUID } = payload
      const response = await articlesentimentv2.fetchArticleSentimentV2Config({ siteUUID })
      return response.data
    }
);

export const updateArticleSentimentV2Config = createAsyncThunk('articlesentimentv2/updateArticleSentimentV2Config',
    async (payload, { rejectWithValue }) => {
        const { data, unitUUID, section } = payload
        log({ unitUUID: unitUUID, data, section })
        try {
            const response = await articlesentimentv2.updateArticleSentimentV2Config({ unitUUID: unitUUID, data, section })
            store.dispatch(displaySuccessMessage('Article sentiment config updated.'))
            return {...response.data}            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = errResponse?.payload || 'There was an issue updating article sentiment config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateArticleSentimentV2DisplayConfig = createAsyncThunk('articlesentimentv2/updateDisplayConfig',
    async (payload, { rejectWithValue, getState }) => {
        const { displayConfig, siteId } = payload
        const state = getState();

        log(displayConfig)
    
        try {
            const response = await articlesentimentv2.updateArticleSentimentV2DisplayConfig({ siteId: siteId, data: {
                config: displayConfig            } })
            store.dispatch(displaySuccessMessage('Display config updated.'))
            log('display config', displayConfig)
            return {config: displayConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = 'There was an issue updating display config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const setThemeForAllProducts = createAsyncThunk('articlesentimentv2/setThemeForAllProducts',
  async (payload, { rejectWithValue, getState }) => {
      const { displayConfig, siteId, accountId } = payload
      const state = getState();

      log(payload)
  
      try {
          const response = await ppa.setThemeForAllProducts({data: payload, siteId: payload.siteId})
          store.dispatch(displaySuccessMessage('Display config updated.'))
          log('display config', displayConfig)
          return true
          
      } catch(err) {
          const errResponse = err.response ? rejectWithValue(err.response.data) : null
          const error = 'There was an issue setting theme for all products'
          store.dispatch(displayErrorMessage(error))
          return errResponse
      }
  }
);

export const fetchEmojisCategories = createAsyncThunk('articlesentimentv2/fetchArticleSentimentV2EmojisCategories',
    async () => {
      const response = await articlesentimentv2.fetchEmojisCategories()
      return response.data
    }
);


// ARTTICLE SENTIMENT ANALYTICS

export const fetchReactionClickRateReport = createAsyncThunk(
  'articlesentimentv2/fetchReactionClickRateReport',
  async ({ requestData }) => {
      const response = await pa.postArticleSentimentReactionClickRateRequest({ requestData });
      return response.data
  }
);


export const fetchReactionClicksReport = createAsyncThunk(
  'articlesentimentv2/fetchReactionClicksReport',
  async ({ requestData }) => {
      const response = await pa.postArticleSentimentReactionClicksRequest({ requestData });
      return response.data
  }
);


export const fetchPopularArticlesReport = createAsyncThunk(
  'articlesentimentv2/fetchPopularArticlesReport',
  async ({ requestData }) => {
      const response = await pa.postArticleSentimentPopularArticlesRequest({ requestData });
      return response.data
  }
);


export const fetchPopularArticlesExportAll = createAsyncThunk(
  'articlesentimentv2/fetchPopularArticlesExportAll',
  async ( requestData ) => {
      const response = await pa.postArticleSentimentExportPopularArticlesRequest({ requestData });
      if(response?.data?.exportedFileUrl){
          //download file
          downloadLink(response.data.exportedFileUrl)
      }
      return response.data
  }
);



export const fetchInViewRateReport = createAsyncThunk(
  'articlesentimentv2/fetchInViewRateReport',
  async ({ requestData }) => {
      const response = await pa.postArticleSentimentInViewRateRequest({ requestData });
      return response.data
  }
);

export const fetchTotalEmbedLoadsReport = createAsyncThunk(
  'articlesentimentv2/fetchTotalEmbedLoadsReport',
  async ({ requestData }) => {
      const response = await pa.postArticleSentimentTotalEmbedLoadsRequest({ requestData });
      return response.data
  }
);

